.strip {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 5px;
}

@media (min-width: 720px) {
  .strip {
    display: none;
  }
}

.day {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  min-height: 52px;
  padding: 6px 0;
  border: var(--outline);
  border-radius: var(--radius-control);
  color: var(--ink);
  cursor: pointer;
}

/* The green and the yellow keep their colour in both themes, so their text
 * is the accent's dark ink in both, as on the completeness chip: --ink turns
 * light in the dark theme and would not read on either. */
.COMPLETE {
  background: var(--done);
  color: var(--accent-ink);
}

.PARTIAL {
  background: var(--accent);
  color: var(--accent-ink);
}

.NONE {
  background: var(--surface);
}

.future {
  border-style: dashed;
  border-color: var(--ink-3);
  background: var(--surface);
  opacity: 0.6;
  cursor: default;
}

.selected {
  box-shadow: var(--shadow-button);
}

.letter {
  font-size: 11px;
  font-weight: 600;
}

.number {
  font-size: 15px;
  font-weight: 700;
}
